import { Drawer } from './styles';

interface Props {
  open?: boolean;
  children: React.ReactNode;
}

const DrawerMenu = ({ open, children }: Props) => {
  return (
    <Drawer variant="permanent" open={open} data-cy={open ? 'menu-is-open' : 'menu-is-closed'}>
      {children}
    </Drawer>
  );
};

export default DrawerMenu;
